module.exports = "pegasus/assets/blocks/column-14-theme2.png";